import React from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import style from "./ConfirmActionModal.module.scss";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import CloseIconNew from "../../../../shared/icons/CloseIconNew";

const ConfirmActionModal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  isLoading = false,
  isDisabled = false,
  confirmText,
  cancelText,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={style.overlay} onClick={onCancel} data-portal-modal="true">
      <div className={style.modal} onClick={(e) => e.stopPropagation()}>
        <button
          className={style.close_btn}
          onClick={onCancel}
          aria-label={t("orderInfoExpeditor.assignDriverModal.close")}
        >
          <CloseIconNew width="24" height="24" fill="#212121" />
        </button>
        <div className={style.body}>
          <p className={style.title}>{title}</p>
          {message && <p className={style.description}>{message}</p>}
        </div>
        <div className={style.footer}>
          <div className={style.footer_btn}>
            <CustomButton
              text={cancelText || t("common.cancel")}
              isNavy
              isWhite
              onClick={onCancel}
              disabled={isLoading}
              style={{ width: "100%" }}
            />
          </div>
          <div className={style.footer_btn}>
            <CustomButton
              text={confirmText || t("common.confirm")}
              isNavy
              onClick={onConfirm}
              isLoading={isLoading}
              disabled={isLoading || isDisabled}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmActionModal;
